import CarRentalPage from "./rental";
function App() {
  return (
    <div className="App">
      <CarRentalPage/>
    </div>
  );
}

export default App;
